import { SchemaFactory } from 'fluid-framework';
import { CalendarDate } from './calendar/index.js';
import { TreeReference } from './TreeReference.js';
const schemaFactory = new SchemaFactory('datapad.campaign');
export class Campaign extends schemaFactory.object('campaign', {
    id: schemaFactory.identifier,
    name: schemaFactory.string,
    activeCharacters: schemaFactory.array(TreeReference),
    inactiveCharacters: schemaFactory.array(TreeReference),
    currentDate: schemaFactory.optional(CalendarDate),
    imageResourceName: schemaFactory.optional(schemaFactory.string),
}) {
}
//# sourceMappingURL=Campaign.js.map